import { CALL_EMAIL_REQUIRED_MODAL } from "../../redux/actions/action.types";

export default function callEmailRequiredModal(stateHandler: any, stateOptions: any) {
  stateHandler({
    type: CALL_EMAIL_REQUIRED_MODAL,
    payload: stateOptions,
  });
}
